/**
 * @file       CyAccess service for logged in user
 * @version    2.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */

import { Injectable } from '@angular/core';
import { ERROR } from '@app/constants/Error.constant';
import { ACCESS } from '@app/constants/Api.constant';
//import { debounce } from 'rxjs/operators';
import { Observable, catchError, map, of } from 'rxjs';

import { ApiService } from '@app/secure/service/Api.service';

export interface CyAccess 
{
    name: string;
}

@Injectable
({
    providedIn: 'root'
})

class CyAccessService 
{
    constructor
    (
        private apiService: ApiService
    ) 
    {}

    public createCaseManagementSession
    (
        uId: any
    ) : Observable<any>
    {
        let cyResult: any;
        let errorParts: any;
        let postData: any;
        let serviceObj: any;

        postData = 
        {
            uId: uId,
            withCredentials: true
        }

        serviceObj = this.apiService
            .post<any>(
                `access/createCaseManagementSession`, 
                    postData)
        .pipe(map((data: any) =>
        {
            cyResult =
            {
                cyData: {},
                errorCode: ERROR.NO_ERROR,
                errorMessage: null
            };
            cyResult.cyData = data;

            return cyResult;
        }),
        catchError((err) =>
        {
            errorParts = err.message.split(',');
            cyResult = 
            { 
                updated: false,
                errorCode: null,
                errorMessage: null 
            };

            if (errorParts && errorParts.length > 1 && errorParts[0])
            {
                switch (errorParts[1])
                {
                    case ERROR.GENERAL_DB:
                        cyResult.errorCode = errorParts[1];
                        cyResult.errorMessage = 'General DB Error';
                        break;
                    default:
                        cyResult.errorCode = errorParts[1];
                        cyResult.errorMessage = 'General Error';
                        break;
                }
            }

            return of(cyResult);
        }));

        return serviceObj;        
    }

    async addUpdateCyAccess
    (
        uId: String
    )
    {
        let result;
        let data;
        let response: any;

        data =
        {
            uId: uId
        };
        try
        {
            response = await this.apiService.postRaw<any>(
                ACCESS.ADD_UPDATE_CYPHER_ACCESS,
                data
            ).toPromise();

            if (
                response?.cyData?.accessKey ||
                response?.error === ERROR.NO_ERROR
            )
            {
                result = response;
            }
        }
        catch (error)
        {
            console.log('Error: ', error);
        }

        return result;
    }

    public deleteAccess
    (
        uId: string
    ) : Observable<any>
    {
        let cyResult: any;
        let errorParts: any;
        let postData: any;
        let serviceObj: any;

        postData =
        {
            uId: uId
        }

        serviceObj = this.apiService
            .post<any>(
                ACCESS
                    .DELETE_ACCESS,
                postData)
        .pipe(map((data: any) =>
        {
            cyResult =
            {
                cyData: {},
                errorCode: ERROR.NO_ERROR,
                errorMessage: null
            };
            cyResult.cyData = data;

            return cyResult;
        }),
        catchError((err) =>
        {
            errorParts = err.message.split(',');
            cyResult =
            {
                deleted: false,
                errorCode: null,
                errorMessage: null
            };

            if (errorParts &&
                errorParts.length > 1 &&
                errorParts[0])
            {
                cyResult.errorCode =
                    errorParts[1];
                cyResult.errorMessage =
                    'Delete access error';
            }

            return of(cyResult);
        }));

        return serviceObj;
    }
}

export { CyAccessService };
